module.exports = __webpack_public_path__ + "static/media/arrow-right.08daf8e3.svg";